import { Button, ButtonGroup, InlineStack, KeyboardKey, Text } from '@shopify/polaris';

/*
  Bottom action bar of a card. actions: [{ id, content, onAction, variant, tone, disabled, loading, shortcut, disabledReason }]
*/
export default function ActionBar({ actions = [], hint }) {
  return (
    <InlineStack align="space-between" blockAlign="center" wrap>
      <Text variant="bodySm" tone="subdued">
        {hint || ''}
      </Text>
      <ButtonGroup>
        {actions.map((action) => (
          <span key={action.id} title={action.disabled && action.disabledReason ? action.disabledReason : undefined} style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            <Button id={action.id} variant={action.variant} tone={action.tone} onClick={action.onAction} disabled={action.disabled} loading={action.loading}>
              {action.content}
            </Button>
            {action.shortcut ? <KeyboardKey>{action.shortcut}</KeyboardKey> : null}
          </span>
        ))}
      </ButtonGroup>
    </InlineStack>
  );
}
